<template>
<div class="d-flex flex-column flex-root" v-loading="loading" >
        <div class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-signin-on">
            <div class="login-aside d-flex flex-column flex-row-auto" style="background-color: #f2c98a">
                <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
                    <a href="#" class="text-center mb-10">
                        <img src="media/logos/logo-letter-1.png" class="max-h-70px" alt="" />
                    </a>
                </div>
                <div class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
                    :style="{ backgroundImage: `url(${backgroundImage})` }"></div>
            </div>
            <div
                class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
                <div class="d-flex flex-column-fluid flex-center">
                    <!--begin::Signin-->
                    <div class="login-form login-signin">
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { IS_LOADING } from "@/core/services/store/htmlclass.module";

export default {
    name: "LayoutLogin",
    computed: {
        backgroundImage() {
            return process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg";
        },
        loading(){
            return this[IS_LOADING]()
        }
    },
    methods:{
        ...mapGetters([IS_LOADING])
    }
}
</script>


<style lang="scss">
.input-login {
    input {
        &:focus {
            color: #3F4254;
            background-color: #EBEDF3;
            border-color: #69b3ff;
            outline: 0;
        }

        -webkit-transition: color 0.15s ease,
        background-color 0.15s ease,
        border-color 0.15s ease,
        -webkit-box-shadow 0.15s ease;
        transition: color 0.15s ease,
        box-shadow 0.15s ease;
        height: auto;
        display: block;
        width: 100%;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;

        background-clip: padding-box;
        border: 1px solid #E4E6EF;
        -webkit-box-shadow: none;
        box-shadow: none;
        -webkit-transition: border-color 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out,
        -webkit-box-shadow 0.15s ease-in-out;
    }

    .el-input__suffix {
        display: none;
    }
}

.el-form-item {
    .el-input__inner {
        background-color: #F3F6F9;
        border-color: #F3F6F9;
        color: #3F4254;
        height: auto;
        padding: 1rem 1.5rem;
        border-radius: 0.85rem !important;
        line-height: unset;
    }

    &.is-error .el-form-item__error {
        margin-top: 0.2rem;
    }

    .el-form-item__error {
        position: relative;
        line-height: normal;
    }
}
</style>

<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>
